import io from 'socket.io-client';
import * as _ from 'lodash';

export default {
    state: {
        isConnected: false,
        socketMessage: '',
        socketSubscriptions: [],
        connection: void 0,
    },
    mutations: {
        socketConnect(state, status) {
            state.isConnected = status;
        },
        socketMessage(state, payload) {
            state.socketMessage = payload;
        },
        socketSubscribe(state, payload) {
            state.socketSubscriptions.push(payload);
        },
        socketUnSubscribe(state, payload) {
            // remove from stack
            for (let i = 0 ; i < state.socketSubscriptions.length; i++) {
                if (   state.socketSubscriptions[i].name == payload.name
                    && state.socketSubscriptions[i].params.user_id == payload.params.user_id
                    && state.socketSubscriptions[i].params.channel == payload.params.channel
                ) {
                    state.socketSubscriptions.splice(i, 1);
                    break; // foinded exit
                }
            }
        },
    },

    actions: {
        async setupSocketConnection({ commit, dispatch, state }) {
            // commit('clearError')
            commit('setLoading', true);

            return new Promise((resolve) => {
                state.connection = io(this._vm.appConfig.app_socket_url, { transports: ['websocket']});
                state.connection.on('connect', function () {
                    commit('setLoading', false);
                    commit('socketConnect', true);
    
                    // restore subscriptions when reconnect
                    for (var i = 0; i < state.socketSubscriptions.length; i++) {
                        state.connection.emit(state.socketSubscriptions[i].name + ':subscribe', state.socketSubscriptions[i].params);
                    }

                    if (resolve) {
                        // on first connection
                        resolve();

                        // subscribe to channel `private:panelmessages`
                        dispatch('socketSubscribe', {
                            name: 'private:panelmessages',
                            params: {
                                user_id: 1,
                                channel: void 0,
                            }
                        });
                    }
                });
    
                state.connection.on('exception', function (data) {
                    console.log('event', data);
                    dispatch('setError', data);
                });
    
                state.connection.on('disconnect', function () {
                    console.log('event', "Disconnected!");
                    //dispatch('setError', 'Disconnected');
                    commit('socketConnect', false);
                });

                state.connection.on('error', function (err) {
                    console.log(err);
                });
    
                // subscribe to admin panel messages
                state.connection.on('private:panelmessages', function (message) {
                    if (!message.success || !message.data || !message.data.channel || !message.data.items) {
                        console.log('Soket error: ', message);
                        return; // exit
                    }
        
                    switch(message.data.channel) {
                        case 'timesheet_channel':
                            if (
                                message.data.event == 'store'
                                || message.data.event == 'start'
                                || message.data.event == 'reject' // ?
                            ) {
                                _.each(message.data.items, item => {
                                    if (item.data && item.table === 'drivershare') {
                                        commit('addDrivershareTimesheet', item.data);
                                    } else {
                                        commit('createNewTimesheet', item.data);
                                        commit('editShiftTimeSheet', item.data);
                                    }
                                })
                            } else if (
                                   message.data.event == 'update'
                                || message.data.event == 'finish'
                            ) {
                                _.each(message.data.items, item => {
                                    if (item.data && item.table === 'drivershare') {
                                        commit('editDrivershareTimesheet', item.data);
                                    } else {
                                        commit('editTimesheet', item.data);
                                        commit('editShiftTimeSheet', item.data);
                                    }
                                })
                            } else if (
                                message.data.event == 'destroy'
                            ) {
                                _.each(message.data.items, item => {
                                    commit('removeShiftTimeSheet', item.data);
                                })
                            }
                            break;
                        case 'shift_channel':
                            if (message.data.event == 'store') {
                                _.each(message.data.items, item => {
                                    if (item.table === 'drivershare') {
                                        commit('addDrivershareShift', item.data);
                                    } else {
                                        commit('createNewShift', item.data);
                                    }
                                })
                            } else if (message.data.event == 'update' || message.data.event == 'unpublish' || message.data.event == 'publish' || message.data.event == 'reject' || message.data.event == 'request') {
                                _.each(message.data.items, item => {
                                    if (item.table === 'drivershare') {
                                        commit('editDrivershareShift', item.data);
                                    } else {
                                        commit('editShift', item.data);
                                    }
                                })
                            } else if (message.data.event == 'destroy') {
                                _.each(message.data.items, item => {
                                    if (item.table === 'drivershare') {
                                        commit('removeDrivershareShift', item.data.id);
                                    } else {
                                        commit('removeShift', item.data);
                                    }
                                })
                            }
                            break;
                        case 'news_feed_channel':
                            if (message.data.event == 'store' || message.data.event == 'publish') { // 'publish' from driver
                                _.each(message.data.items, item => {
                                    commit('addPostsToList', item.data);
                                })
                            } else if (message.data.event == 'update' || message.data.event == 'markReaded' || message.data.event == 'changeStatus') {
                                _.each(message.data.items, item => {
                                    commit('editPost', item.data);
                                })
                            } else if (message.data.event == 'destroy') {
                                _.each(message.data.items, item => {
                                    commit('deletePost', item.data);
                                })
                            }
                            break;
                        case 'reply_channel':
                            if (message.data.event == 'store' || message.data.event == 'post') { // 'post' from driver
                                _.each(message.data.items, item => {
                                    commit('addReplyToList', item.data);
                                })
                            }
                            break;
                        case 'alert_channel':
                            // message.data.event == 'store'
                            _.each(message.data.items, item => {
                                commit('addAlert', item.data);
                            })
                            break;
                        case 'driver_channel':
                            if (message.data.event == 'store') {
                                _.each(message.data.items, item => {
                                    commit('addDriversToList', item.data);
                                })
                            } else if (message.data.event == 'update') {
                                _.each(message.data.items, item => {
                                    commit('editDriver', item.data);
                                })
                            // } else if (message.data.event == 'destroy') {
                            //     _.each(message.data.items, item => {
                            //         commit('removeDriver', item.data);
                            //     })
                            }
                            break;
                        case 'notification_channel':
                            // driver notifications channel
                            break;
                        default:
                            console.log('Unknown channel: ' + message.data.channel, message )
                    }

                    commit('socketMessage', message);
                });
            });
        },

        socketSubscribe({ commit, state }, subscription) {
            if (state.isConnected) {
                state.connection.emit(subscription.name + ':subscribe', subscription.params);
                commit('socketSubscribe', subscription);
            }
        },
    
        socketUnSubscribe({ commit, state }, subscription) {
            state.connection.emit(subscription.name + ':unsubscribe', subscription.params);
            commit('socketUnSubscribe', subscription);
        },
    },

    getters: {
        status(state) {
            return state.isConnected;
        },
        message(state) {
            return state.socketMessage;
        },
    }
}